module.exports = __webpack_public_path__ + "img/coinbankB43.8dcde3a3.jpg";